import type { ReactNode } from 'react';

/**
 * LegalDoc / LegalSection — shared chrome for the Privacy + Terms pages, so both
 * read as one calm, on-brand document (serif heads, hairline dividers, prose
 * measure) rather than a wall of boilerplate.
 */
export function LegalDoc({
  title,
  updated,
  intro,
  children,
}: {
  title: string;
  updated: string;
  intro: ReactNode;
  children: ReactNode;
}) {
  return (
    <article className="mx-auto flex max-w-2xl flex-col gap-9">
      <header className="flex flex-col gap-2">
        <span className="kicker">Gilding</span>
        <h1 className="heading-display">{title}</h1>
        <p className="font-display italic text-caption text-ink-subtle">Last updated {updated}</p>
        <p className="mt-2 max-w-prose font-body text-caption leading-relaxed text-ink-soft">{intro}</p>
      </header>
      <div className="flex flex-col gap-8">{children}</div>
    </article>
  );
}

export function LegalSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="flex flex-col gap-3">
      <h2 className="heading-section text-[1.0625rem]">{title}</h2>
      <div className="flex flex-col gap-3 font-body text-caption leading-relaxed text-ink-soft">
        {children}
      </div>
    </section>
  );
}

export function LegalList({ items }: { items: ReactNode[] }) {
  return (
    <ul className="flex list-disc flex-col gap-1.5 pl-5 marker:text-accent/70">
      {items.map((it, i) => (
        <li key={i}>{it}</li>
      ))}
    </ul>
  );
}
